import { useMutation } from '@tanstack/vue-query'
import { unfollowUser } from '~~/src/api/users'

export function useUnfollowUserMutation() {
  const { firebaseUser } = useFirebaseAuth()
  const toast = useToast()
  return useMutation<
    Awaited<ReturnType<typeof unfollowUser>>,
    Error,
    string
  >({
    mutationFn: async (userId: string) => {
      if (!firebaseUser.value)
        throw new Error('You must be logged in to unfollow a user')

      if (firebaseUser.value.uid === userId)
        throw new Error('You cannot unfollow yourself')

      return await unfollowUser(userId)
    },
    onSuccess: () => {
      toast.info('User unfollowed')
    },
    onError: (err) => {
      toast.error(err.message)
    },
  })
}
